import React from "react";
import "./glossarblogs.scss";
import "bootstrap/dist/css/bootstrap.min.css";

function Glossar() {
  return (
    <div className="glossar">
      <h1>Glossar (Immobilienmarkt)</h1>
      <h5>Abgeschlossenheit:</h5>
      <p>
        Sie ist neben dem Aufteilungsplan Voraussetzung für die Einräumung von
        Sondereigentum (Wohnungs- bzw. Teileigentum). Sondereigentum gilt gemäß
        LBO als abgeschlossen, wenn es baulich von anderen Einheiten abgegrenzt
        ist (insbesondere durch Wände und Decken) und über einen abschließbaren
        Zugang verfügt. Die Abgeschlossenheit wird mit der
        Abgeschlossenheitsbescheinigung von der zuständigen Baubehörde
        bestätigt.
      </p>

      <h5>Alterswertminderung: </h5>
      <p>
        Die Alterswertminderung wird ermittelt unter Berücksichtigung des
        Verhältnisses der Restnutzungsdauer zur Gesamtnutzungsdauer der
        baulichen Anlagen. In der Regel wird eine gleichmäßige Wertminderung
        zugrunde gelegt.
      </p>

      <h5>Aufteilungsplan : </h5>
      <p>
        Der Aufteilungsplan ist eine Bauzeichnung, aus der ersichtlich wird,
        welche Teile des Gebäudes dem Sonder- bzw. dem Gemeinschaftseigentum
        zugeordnet sind.{" "}
      </p>

      <h5> Barwertfaktor (auch: Vervielfältiger):</h5>
      <p>
        {" "}
        Eine Rechengröße, die sich aus Restnutzungsdauer der Immobilie und dem
        Liegenschaftszins ableitet. Der Vervielfältiger lässt sich auch aus den
        Tabellen im Anhang 1 und 2 der ImmoWertV ablesen.
      </p>

      <h5>Beschluss: </h5>
      <p>
        {" "}
        Ein Beschluss ist ein mehrseitiges Rechtsgeschäft, das durch die Abgabe
        von Willenserklärungen der einzelnen Eigentümer während einer
        Eigentümerversammlung entsteht. Mit Beschlüssen wird über
        Angelegenheiten des gemeinschaftlichen Eigentums entschieden. Ein
        Beschluss ist auch ohne Eintragung im Grundbuch gegenüber dem
        Sondernachfolger wirksam.
      </p>

      <h5> Beschluss-Sammlung:</h5>
      <p>
        {" "}
        Die Beschluss-Sammlung dient der Dokumentation von verkündeten
        Beschlüssen, schriftlichen Beschlüssen und Urteilsformeln von
        gerichtlichen Entscheidungen im Rahmen eines Rechtsstreits (vgl. dazu §
        24 Abs. 7 Nr. 1 – 3 WEG). Bewirtschaftungskosten: Kosten, die bei der
        ordnungsmäßigen Bewirtschaftung eines Gebäudes oder eines Grundstückes
        anfallen und nicht auf die Mieter umzulegen sind, zum Beispiel
        Verwaltungskosten, Mietausfallwagnis, Instandhaltung oder
        Abschreibungen.
      </p>
      <h5> Bodenwert: </h5>
      <p>
        {" "}
        Entspricht dem Wert eines unbebauten Grundstücks und kann über den
        Bodenrichtwert bestimmt werden.
      </p>

      <h5> Bodenrichtwert: </h5>
      <p>
        {" "}
        Statistischer Durchschnittswert, der den Wert eines Grundstückes bzw.
        eines Baulandes bestimmt.
      </p>

      <h5> Endenergie: </h5>
      <p>
        {" "}
        Energie, die nach Umwandlung und Übertragungsverlusten am Hausanschluss
        ankommt.
      </p>

      <h5> Ertragswert: </h5>
      <p>
        {" "}
        Summe von Bodenwert und Gebäudeertragswert Gemeinschaftseigentum: Dieses
        umfasst alle Gebäudeteile (inkl. Anlagen und Einrichtungen), die dem
        gemeinschaftlichen Gebrauch dienen sowie für den Bestand und die
        Sicherheit des Objekts notwendig sind (vgl. dazu § 5 Abs. 2 WEG).
      </p>

      <h5> Gemeinschaftsordnung:</h5>
      <p>
        {" "}
        Sie regelt das Innenverhältnis – also das Verhältnis der Eigentümer
        untereinander – und gilt somit als „Verfassung“ der Gemeinschaft. In ihr
        sind Vereinbarungen der Wohnungseigentümer verankert, die von den
        gesetzlichen Regelungen abweichen.
      </p>

      <h5>Grundbuch: </h5>
      <p>
        {" "}
        Das Grundbuch ist ein öffentliches Register, das unter anderem
        Aufschluss über die Eigentumsverhältnisse an einem Grundstück gibt.{" "}
      </p>

      <h5> Hausgeld: </h5>
      <p>
        {" "}
        Dabei handelt es sich um einen in der Regel monatlichen Betrag, der zur
        Deckung der anfallenden Kosten des gemeinschaftlichen Eigentums von
        jedem Eigentümer zu zahlen ist.
      </p>

      <h5> Hausordnung:</h5>
      <p>
        {" "}
        Sie enthält Regelungen (Benutzungs-, Ruhezeiten etc.) über das
        Zusammenleben der Bewohner eines Hauses.
      </p>

      <h5> Herstellungskosten:</h5>

      <p>
        {" "}
        Produkt aus Normalherstellungskosten (gewöhnliche Herstellungskosten je
        Flächen-, Raum- oder sonstiger Bezugseinheit) und der Anzahl der
        Bezugseinheiten der baulichen Anlage.
      </p>

      <h5>Instandhaltungsrücklage</h5>
      <p>
        Diese Rücklage ist eine Ansammlung von in der Regel monatlich durch die
        Eigentümer geleisteten Zahlungen zur Deckung eines zukünftigen
        Instandhaltungs- oder
      </p>
      <h5>Jahresabrechnung</h5>
      <p>
        Die Jahresabrechnung jst eine geordnete Aufstellung der tatsächlichen
        Einnahmen und Ausgaben der Wohnungseigentümergemeinschaft und bezieht
        sich auf das jeweils abgelaufene Kalenderjahr. Sie besteht aus einer
        Gesamtabrechnung und Einzelabrechnungen für jeden Wohnungseigentümer.
      </p>
      <h5>Kaltmiete</h5>
      <p>
        Auch Nettomiete oder Grundmiete; Miete, die ausschließlich für die
        Raumnutzung anfällt, ohne Nebenkosten.
      </p>
      <h5>KfW Effizienzhaus 100</h5>
      <p>No definition available</p>
      <h5>
        Ein Gebäude, das die energetischen Vorgaben der EnEV 2014 einhält (100 %
        der Vorgabe) oder unterschreitet. Im Vergleich dazu
      </h5>
      <p>
        Das KfW Effizienzhaus 70 unterschreitet die energetischen Vorgaben der
        EnEV 2014 um min. 30 %, das KfW Effizienzhaus 55 um mindestens 45 %.
      </p>
      <h5>Liegenschaftszins</h5>
      <p>
        Der Zinssatz, zu dem der Verkehrswert des Grundstückes marktüblich
        verzinst wird. Die Höhe des Liegenschaftszinses wird von den
        Kaufpreissammlungen der Gutachterausschüsse abgeleitet und dient der
        Kapitalisierung der künftigen Kosten und Erträge.
      </p>
      <h5>Miteigentumsanteile</h5>
      <p>No definition available</p>
      <h5>Nebenkosten</h5>
      <p>
        Betriebskosten, die bei der Bewirtschaftung von Mietobjekten anfallen
        (z. B. Strom, Heizkosten, Müllabfuhr, Versicherungen etc.).
      </p>
      <h5>Normalherstellungskosten (NHK)</h5>
      <p>No definition available</p>
      <h5>Nutzfläche</h5>
      <p>
        Gemäß DIN 277 handelt es sich bei der Nutzfläche um den Teil der
        Netto-Grundfläche, der nicht als technische Funktionsfläche oder
        Verkehrsfläche genutzt wird. Nutzflächen dienen dementsprechend unter
        anderem dem Wohnen (vgl. dazu DIN 277-2).
      </p>
      <h5>Öffnungsklausel</h5>
      <p>
        Diese Klausel erlaubt es, von den gesetzlichen Bestimmungen abweichende
        Vereinbarungen zu treffen.
      </p>
      <h5>Primärenergie</h5>
      <p>
        Energie in der ursprünglich vorkommenden Energieform (z. B. Kohle oder
        Erdgas).
      </p>
      <h5>Rohertrag</h5>
      <p>
        Alle nachhaltig erzielbaren Mieten. Basis sind die ortsüblichen Mieten,
        nicht die Ist-Miete.
      </p>
      <h5>Sachwert der baulichen Anlagen (ohne Außenanlagen)</h5>
      <p>No definition available</p>
      <h5>
        Sachwert der sonstigen Anlagen (bauliche Außenanlagen und sonstige
        Anlagen)
      </h5>
      <p>No definition available</p>
      <h5>Sachwertfaktor</h5>
      <p>
        Dieser „Marktanpassungsfaktor“ dient dazu, anhand von Wertzahlen der
        Gutachterausschüsse das Rechenergebnis an die Marktpreise anzupassen.
      </p>
      <h5>Sondereigentum</h5>
      <p>
        Sondereigentum ist das Alleineigentum (z. B. die Wohnung), mit dem ein
        Eigentümer nach Belieben Verfahren kann.
      </p>
      <h5>Sondernachfolger</h5>
      <p>
        Als Sondernachfolger wird der Rechtsnachfolger eines
        Wohnungseigentümers, also ein neuer Eigentümer (z. B. nach Verkauf der
        Eigentumswohnung), bezeichnet.
      </p>
      <h5>Sondernutzungsrechte</h5>
      <p>
        Sie befugen einen Wohnungseigentümer zur alleinigen Nutzung eines
        bestimmten im gemeinschaftlichen Eigentum stehenden Teil des Gebäudes
        oder Grundstücks.
      </p>
      <h5>Sonderumlage</h5>
      <p>
        Eine Sonderumlage fällt bei Liquiditätsengpässen an, z. B. wenn die
        Instandhaltungsrücklage nicht zur Kostendeckung ausreicht, und wird per
        Beschluss auf die Wohnungseigentümer umgelegt.
      </p>
      <h5>Sonstige wertbeeinflussende Umstände</h5>
      <p>
        Diese Faktoren können den Ertragswert mindern oder erhöhen, z. B.
        Bauschäden, aufgeschobene Instandhaltungsmaßnahmen, nicht im Rohertrag
        berücksichtigte Mietbindungen.
      </p>
      <h5>Sowieso-Kosten</h5>
      <p>Kosten, die auch ohne eine energetische Sanierung anfielen.</p>
      <h5>Teileigentum</h5>
      <p>
        Dieses setzt sich aus dem Sondereigentum an nicht zu Wohnzwecken
        dienenden Räumen und einem Miteigentumsanteil zusammen.
      </p>
      <h5>Teilungserklärung</h5>
      <p>
        Dies ist eine Erklärung des Grundstückseigentümers gegenüber dem
        Grundbuchamt, welche die Aufteilung des Eigentums an einem Grundstücks
        in Miteigentumsanteile (inkl. dazugehörigem Sondereigentum) zum Inhalt
        hat (vgl. dazu § 8 WEG).
      </p>
      <h5>Teilungsvertrag</h5>
      <p>
        Notariell zu beurkundender Vertrag der einzelnen Bruchteilseigentümer
        eines Grundstücks über die gegenseitige Einräumung von Sondereigentum
        (vgl. dazu § 3 WEG).
      </p>
      <h5>U-Wert</h5>
      <p>
        Wärmedurchgangskoeffizient, (früher k-Wert); er beschreibt die Menge an
        Wärmeenergie(in Watt), die ein Bauteil pro Sekunde und Quadratmeter
        durchströmt.
      </p>
      <h5>Vereinbarung</h5>
      <p>
        Übereinkunft der Wohnungseigentümer in Form eines Vertrages
        (Teilungserklärung, etc.). Eine Vereinbarung bedarf der Zustimmung aller
        Eigentümer und ist nur bei Eintragung in das Grundbuch gegenüber
        etwaigen Sondernachfolgern wirksam (vgl. § 10 Abs. 3 WEG).
      </p>
      <h5>Verwaltungsbeirat</h5>
      <p>
        Der Beirat soll den Verwalter unterstützen und seine Handlungen
        kontrollieren. Er setzt sich aus drei Eigentümern zusammen (vgl. dazu §
        29 WEG).
      </p>
      <h5>Vormerkung</h5>
      <p>
        Dies ist eine Eintragung im Grundbuch, die die Ansprüche eines
        Immobilienerwerbers in der Zeit zwischen Kaufvertragsabschluss und
        Eigentumsübergang sicherstellt.
      </p>
      <h5>Wirtschaftsplan</h5>
      <p>
        Dieser Plan ist Aufstellung über die zu erwartenden Einnahmen und
        Ausgaben der Eigentümergemeinschaft für das kommende Kalenderjahr. Er
        dient als Basis zur Ermittlung des von den einzelnen Eigentümern zu
        entrichtenden Hausgelds.
      </p>
      <h5>Wohnfläche</h5>
      <p>
        Gemäß Wohnflächenverordnung entspricht die Wohnfläche der Summe aller
        Grundflächen der zu einer Wohnung gehörenden Räume. Hierzu gehören z. B.
        auch Bruchteile der Grundflächen von Terrassen oder Balkonen, nicht
        jedoch die von Kellerräumen oder Garagen.
      </p>
      <h5>Wohnungseigentum</h5>
      <p>
        Das Wohnungseigentum setzt sich dem Sondereigentum an zu Wohnzwecken
        dienenden Räumen und einem Miteigentumsanteil zusammen.
      </p>
      <h5>Wohnungseigentümerversammlung</h5>
      <p>
        Sie ist das wichtigste Selbstverwaltungsorgan der Eigentümergemeinschaft
        und dient der Beschlussfassung sowie dem Informations- und
        Meinungsaustausch der Eigentümer. Die Einberufung hat mindestens einmal
        jährlich zu erfolgen.
      </p>
      <h5>Wohnungsgrundbuch</h5>
      <p>
        Hierbei handelt es sich um eine spezielle Form des Grundbuchs, welche
        die Eigentumsverhältnisse an Wohnungseigentum verzeichnet.
      </p>

      <h2> Finanzierungstipps</h2>
      <p> Woran Sie bei Ihrer Finanzierung denken sollten:</p>
      <h4>Altersvorsorge</h4>
      <p>
        Es empfiehlt sich, die Finanzierung selbstgenutzten Wohneigentums so zu
        planen, dass die Immobilie mit dem Eintritt des Bauherrn in den
        Ruhestand möglichst belastungsfrei ist. Ein bezahltes Haus oder eine
        bezahlte Eigentumswohnung ist eine wichtige Säule der Altersvorsorge, da
        dies einerseits das Rentnerbudget um die Miete entlastet und
        andererseits einen inflationssicheren Sachwert darstellt.
      </p>
      <h4>Belastung</h4>
      <p>
        Es ist wichtig, dass die Grenze der eigenen Belastung im Anschluss an
        den Bau oder Kauf eines Objektes nicht überschritten wird. Die
        finanzielle Belastung sollte 40% des Nettofamilieneinkommens nicht
        überschreiten.
      </p>
      <h4>Bereitstellungszinsen</h4>
      <p>
        Am günstigsten für Sie ist es natürlich, wenn überhaupt keine
        Bereitstellungszinsen zu zahlen sind. Die Bereitstellungszinsen werden
        vom finanzierenden Kreditinstitut für den noch nicht ausgezahlten Anteil
        des Gesamtdarlehens berechnet. Von einer soliden Finanzplanung und einem
        geschickten Verhandeln mit den Banken ist es abhängig, wie lange Sie ab
        Unterschrift des Darlehensvertrages keine Bereitstellungszinsen zu
        zahlen haben.
      </p>
      <h4>Darlehenshöhe</h4>
      <p>
        Meiden Sie auf jeden Fall eine Überfinanzierung, bei der die
        Darlehenssumme über den reinen Kaufpreis oder den Kaufpreis und die
        Modernisierungskosten hinausgeht! Die Erwerbsnebenkosten wie
        Grunderwerbssteuer , Grundbuch- und Notarkosten sowie die Maklercourtage
        sollten als Eigenkapital zur Verfügung stehen.
      </p>
      <h4>Fördermittel</h4>
      <p>
        Erkundigen Sie sich, ob Sie für Ihren Bau oder Kauf öffentliche
        Fördermittel in Anspruch nehmen können. Die Bundesländer vergeben
        teilweise zinsgünstige Darlehen und Zuschüsse (einkommensabhängig).
        Angesichts eventueller Wohneigentumsförderung ist es unumgänglich, sich
        genau zu informieren, wie sich diese auf Ihre Finanzierung auswirken
        kann. Lassen Sie sich beraten!
      </p>
      <h4>Nebenkosten</h4>
      <p>
        Bei der Planung der Finanzierung sollte ein wichtiger Faktor, der die
        Gesamtrechnung nicht unerheblich beeinflusst, mit berücksichtigt werden.
        So mancher ist schon in Schwierigkeiten geraten, weil die Nebenkosten
        nicht ausreichend kalkuliert waren. Dabei handelt es sich zum Beispiel
        um Notar-, Grundbuch- und Gerichtskosten sowie Grunderwerbssteuer.
      </p>
      <h4>Restschuld</h4>
      <p>
        Lassen Sie sich zu den Finanzierungsvorschlägen einen Zins- und
        Tilgungsplan erstellen. Daraus können Sie die jeweilige Restschuld
        erkennen, die eine der wichtigsten Vergleichsgrößen bei der Beurteilung
        eines Kreditangebots ist!
      </p>
      <h4>Sondertilgungen</h4>
      <p>
        Freiwillige Sonderzahlung, die über die vereinbarten Ratenzahlungen
        hinausgeht. Wirkt sich laufzeitverkürzend auf ein Darlehen aus. Je nach
        Darlehensgeber sind verschiedene Sondertilgungen kostenfrei möglich.
      </p>
      <h4>Tilgung</h4>
      <p>
        Nutzen Sie das niedrige Zinsniveau dazu, nach Möglichkeit mehr als 1
        Prozent zu tilgen. Je höher die Tilgung angesetzt wird, desto eher sind
        Sie schuldenfrei.
      </p>
      <h4>Zinsbindung</h4>
      <p>
        Lassen Sie sich einen langfristigen Finanzierungsplan erstellen.
        Bevorzugen Sie in der derzeitigen Niedrigzinsphase eine lange
        Zinsbindung von mindestens 10 Jahren.
      </p>
    </div>
  );
}

export default Glossar;
